/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Integrations_Tab_Spaces_DescriptionInputs */



/**
* | output |
* | --- |
* | "Connectors that sync a knowledge corpus. They give the assistant no tools — this switch controls whether your organisation permits them at all. Prohibiting o..." |
*
* @param {Integrations_Tab_Spaces_DescriptionInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const integrations_tab_spaces_description = /** @type {((inputs?: Integrations_Tab_Spaces_DescriptionInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Integrations_Tab_Spaces_DescriptionInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Connectors, die einen Wissensbestand synchronisieren. Sie stellen dem Assistenten keine Tools bereit — dieser Schalter steuert, ob Ihre Organisation sie überhaupt erlaubt. Ein Verbot stoppt neue Verbindungen und erhält bestehende Spaces.")
	return /** @type {LocalizedString} */ ("Connectors that sync a knowledge corpus. They give the assistant no tools — this switch controls whether your organisation permits them at all. Prohibiting one stops new connections and keeps the spaces you already have.")
});